import { render } from "./CreditCard.vue?vue&type=template&id=479cc8a6"
const script = {}

import exportComponent from "/home/runner/work/backoffice-base-vue3/backoffice-base-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__